(function () {
    'use strict';

    angular
        .module('advancedapp')
        .controller('NewsPageController', NewsPageController);

    NewsPageController.$inject = ['$location', 'search_service'];

    function NewsPageController($location, search_service) {
        /* jshint validthis:true */
        var ctrl = this;
        ctrl.title = 'NewsPageController';

        ctrl.init = init;
        ctrl.onCategoryChange = onCategoryChange;
        ctrl.rebindFoundation = rebindFoundation;
        ctrl.filterBy = filterBy;
        ctrl.filterByNewsType = filterByNewsType;
        ctrl.filterByAuthorName = filterByAuthorName;
        ctrl.filterByDate = filterByDate;
        ctrl.sort = sort;
        ctrl.searchUrl = "";
        ctrl.sortOptions = [{ value: 1, text: 'Date: Newest to Oldest' }, { value: 2, text: 'Date: Oldest to Newest' }];
        ctrl.criteria = {};
        ctrl.selectedDate = "";

        function onCategoryChange(model) {

            ctrl.criteria = model;
            searchWithCats(ctrl.criteria);
        }

        function filterBy() {
            var searchKeyword = angular.element(document.getElementById("search"));
            //console.log(searchKeyword.val());
            ctrl.criteria = {
                categories: [],
                sortBy: 0,
                rootPageId: ctrl.rootPageId,
                filterByNewsType: "",
                filterByAuthor: "",
                searchTerm: searchKeyword.val(),
            }
            //console.log(ctrl.criteria);
            searchWithCats(ctrl.criteria);
        }

        function filterByNewsType(newsType) {
            //console.log(newsType);
            ctrl.criteria = {
                categories: [],
                sortBy: 0,
                rootPageId: ctrl.rootPageId,
                filterByNewsType: newsType,
                filterByAuthor: "",
                searchTerm: "",
            }
            //console.log(ctrl.criteria);
            searchWithCats(ctrl.criteria);
        }

        function filterByAuthorName(authorName) {
            //console.log(authorName);
            ctrl.criteria = {
                categories: [],
                sortBy: 0,
                rootPageId: ctrl.rootPageId,
                filterByNewsType: "",
                filterByAuthor: authorName,
                searchTerm: "",
            }
            //console.log(ctrl.criteria);
            searchWithCats(ctrl.criteria);
        }

        function filterByDate() {
            var dateValue = angular.element(document.getElementById("datepicker"));
            //console.log(dateValue.val());
            ctrl.selectedDate = dateValue.val();
            ctrl.criteria = {
                categories: [],
                sortBy: 0,
                rootPageId: ctrl.rootPageId,
                filterByNewsType: "",
                filterByAuthor: "",
                filterByDateRange: dateValue.val(),
                searchTerm: "",
            }
            //console.log(ctrl.criteria);
            searchWithCats(ctrl.criteria);
        }

        function init(data, rootPageId, url, filterByNewsType, filterByAuthor) {
            ctrl.results = data;
            ctrl.searchUrl = url.url;
            ctrl.rootPageId = rootPageId;
            ctrl.criteria.rootPageId = rootPageId;
            ctrl.criteria.filterByNewsType = filterByNewsType;
            ctrl.criteria.filterByAuthor = filterByAuthor;
            //console.log(rootPageId);
        }

        function sort(value) {
            //console.log($location);
            ctrl.criteria.sortBy = value;
            searchWithCats(ctrl.criteria);
        }

        function searchWithCats(model) {
            /* as we are now forcing all urls to end with /, the search url no longer
                needs the leading / in the string concat below */
            var searchUrl = ctrl.searchUrl + 'search/';

            return search_service.search(searchUrl, model)
                .then(function (result) {
                    ctrl.results = result;
                    return result;
                });
        }

        function rebindFoundation() {
            Foundation.reInit($('[data-equalizer]'));
        }
    }
})();